<template>
    <div class="date-wrap">
        <div class="accelerator-select">
            <a
                v-for="(time ,i) in time_select"
                :key="i"
                href="javascript:;"
                :class="[{ active : type === time.type && time_value === time.value }]"
                :data-type="time.type"
                :data-value="time.value"
                @click="changeTimeSelect">
                {{ time.text }}
            </a>
        </div>
        <daterange @change="changeDate"></daterange>
    </div>
</template>
<script>
import Daterange from '@/components/daterange'
export const TYPES = {
    RANGE: 'range',
    POINT: 'day',
    LAST_DAY: 'last_days'
}

const TODAY = {
    text: '今日',
    value: 'today',
    type: TYPES.POINT
}

const OTHERS = [
    {
        text: '昨日',
        value: 'yesterday',
        type: TYPES.POINT
    },
    {
        text: '最近7天',
        type: TYPES.LAST_DAY,
        value: '7'
    },
    {
        text: '最近30天',
        type: TYPES.LAST_DAY,
        value: '30'
    }
]
const ALL_DATE = [
    TODAY,
    ...OTHERS
]
export default {
    components: {
        Daterange
    },
    props: {
        type: String,
        time_value: String,
        show_today: Boolean
    },
    computed: {
        time_select () {
            return this.show_today ? ALL_DATE : OTHERS
        }
    },
    methods: {
        changeDate (start, end) {
            this.$emit('changeDate', start, end)
        },
        changeTimeSelect (e) {
            this.$emit('changeTimeSelect', e)
        }
    }
}
</script>
<style lang="scss" scoped>
.date-wrap {
    display: flex;
}
</style>
